import { Base } from '../base-component';
import './banner-three-step-promo.component.scss';

export class BannerThreeStepPromo extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/banner-three-step-promo/banner-three-step-promo.component.ts